import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Flip from 'react-reveal/Flip'
import { FormattedMessage, injectIntl } from "gatsby-plugin-intl"

import iconlink from '../../images/icon-link.svg'


const suite = ({intl}) => (

  	<Layout>

		<SEO
			title={intl.formatMessage({ id: "microservicios.titulo" })}
		/>

		<div style={{background: '#fff', padding: '1'}}>
			<div className="heading-banner-simple">
				<div className="cont">
					<div className="titulo">
						<h1><FormattedMessage id="microservicios.titulo" /></h1>
					</div>
				</div>
			</div>
		</div>

		<section className="recursos-blocks">
			<div className="cont">

				<div className="item">
					<div className="inner-cont">
						<Flip top>
							<div className="icon">
								<svg width="63" height="61" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.861 20.783v.684l7.342 4.218v-.493a.596.596 0 0 1 .299-.517l.175-.1-7.22-4.153-.596.361zM27.393 25.546v.838l8.065 4.631v-.27a.596.596 0 0 1 .298-.517l.362-.207-8.244-4.75-.481.274zM35.461 60.408v-1.03L19.84 50.362c-.187.351-.394.69-.62 1.018l16.54 9.54a.597.597 0 0 1-.298-.512zM9.89 15.652l.02-.036-.02.036zM11.011 35.026V16.96l6.659 3.824v-.361a.596.596 0 0 1 .298-.517l.298-.171-6.67-3.832-.875.52a.593.593 0 0 1-.902-.524v19.12c.266-.02.532-.032.795-.032l.397.04zM9.973 15.532l.023-.028-.023.028z" fill="#fff"/><path d="M62.294 15.918a.597.597 0 0 1-.898.528l-.87-.52L36.121 30.01l-.362.206a.596.596 0 0 0-.298.517v29.679a.597.597 0 0 0 .298.516h.04a.576.576 0 0 0 .556 0L62 46.22a.596.596 0 0 0 .298-.517V15.93s-.004-.008-.004-.012zm-1.192 29.416L36.655 59.378V31.075l24.45-14.112v28.37h-.003zM62.115 15.504l.024.028-.024-.028zM62.19 15.616l.02.036-.02-.036z" fill="#fff"/><path d="M10.72 16.446l.875-.52L36.058 1.297l7.02 4.198.883-.51a.596.596 0 1 1 .592 1.034l-.302.175 7.072 4.23.882-.509a.596.596 0 1 1 .592 1.034l-.302.175 8.03 4.802.87.52a.596.596 0 0 0 .883-.664v-.02a.602.602 0 0 0-.044-.107l-.02-.035a.593.593 0 0 0-.063-.084l-.024-.028a.59.59 0 0 0-.107-.083L36.352.085a.596.596 0 0 0-.612 0L10.116 15.42a.602.602 0 0 0-.107.083l-.024.028a.596.596 0 0 0-.064.084l-.02.035a.598.598 0 0 0-.043.108v.02a.6.6 0 0 0 0 .139.593.593 0 0 0 .862.528z" fill="#fff"/><path d="M17.963 32.22l8.535 4.957a.597.597 0 0 0 .894-.517V25.53l.477-.275 24.623-14.151.302-.175a.597.597 0 1 0-.592-1.034l-.883.51-24.646 14.163-.175.099a.596.596 0 0 0-.298.517V35.61l-7.338-4.25V20.783l.6-.346L44.252 6.19l.301-.175a.597.597 0 1 0-.592-1.033l-.883.509-24.817 14.263-.298.17a.597.597 0 0 0-.294.498v11.265a.597.597 0 0 0 .294.533zM21.064 45.465A10.455 10.455 0 0 0 11.011 35.03h-.398c-.27 0-.536 0-.795.032a10.439 10.439 0 1 0 11.246 10.403zm-19.693 0a9.25 9.25 0 1 1 9.25 9.25 9.262 9.262 0 0 1-9.25-9.25z" fill="#fff"/><path d="M16.127 43.08a.596.596 0 1 0-.84-.847l-.794.795-4.671 4.611-2.564-2.385-.25-.234a.596.596 0 0 0-.795.87l3.231 3.021a.596.596 0 0 0 .827 0l5.856-5.831z" fill="#fff"/></svg>
							</div>
						</Flip>
						<div className="top">
							<h2><FormattedMessage id="microservicios.area_logistica" /></h2>
							<p><FormattedMessage id="microservicios.area_logistica_desc" /></p>
						</div>
						<footer>
							<table>
								<tr>
									<td>
										<a className="btn btn-solid verde" href="https://global.akzent.mx/" target="_blank" rel="noopener noreferrer"><img src={iconlink} alt="Link" aria-hidden="true"/><FormattedMessage id="microservicios.area_logistica_gravity" /></a>
									</td>
								</tr>
								<tr><td>&nbsp;</td></tr>
								<tr>
									<td>
									<a className="btn btn-solid verde" href="https://softcargo.akzent.mx/" target="_blank" rel="noopener noreferrer"><img src={iconlink} alt="Link" aria-hidden="true"/><FormattedMessage id="microservicios.area_logistica_softcargo" /></a>
									</td>
								</tr>
								<tr><td>&nbsp;</td></tr>
								<tr>
									<td>
										<a className="btn btn-solid verde" href="https://akzentfreight.logisticallytms.com/" target="_blank" rel="noopener noreferrer"><img src={iconlink} alt="Link" aria-hidden="true"/><FormattedMessage id="microservicios.area_logistica_logistically" /></a>
									</td>
								</tr>
							</table> 

						</footer>
					</div>
				</div>

				<div className="item">
					<div className="inner-cont">
						<Flip top>
							<div className="icon">
								<svg width="59" height="59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M55.776 58.006H3.069A3.073 3.073 0 0 1 0 54.936v-31.96a3.073 3.073 0 0 1 3.069-3.068l52.237-.485a3.073 3.073 0 0 1 3.073 3.069v32.91a2.607 2.607 0 0 1-2.603 2.604zm-.466-37.39L3.073 21.1a1.88 1.88 0 0 0-1.88 1.876v31.96a1.876 1.876 0 0 0 1.876 1.877h52.707a1.411 1.411 0 0 0 1.41-1.411V22.499a1.878 1.878 0 0 0-1.876-1.884z" fill="#fff"/><path d="M53.653 53.97H5.096a.596.596 0 1 1 0-1.192h48.557a.596.596 0 0 1 0 1.193z" fill="#fff"/><path d="M5.096 53.708a.596.596 0 0 1-.596-.596V24.515a.596.596 0 0 1 1.193 0v28.593a.596.596 0 0 1-.597.6zM9.902 53.708a.596.596 0 0 1-.596-.596V24.515a.596.596 0 0 1 1.192 0v28.593a.597.597 0 0 1-.596.6zM14.8 53.398a.596.596 0 0 1-.597-.596V24.515a.596.596 0 1 1 1.193 0v28.287a.596.596 0 0 1-.597.596zM19.605 53.97a.596.596 0 0 1-.596-.596v-28.86a.596.596 0 1 1 1.192 0v28.86a.596.596 0 0 1-.596.597zM24.503 53.97a.596.596 0 0 1-.597-.596v-28.86a.596.596 0 0 1 1.193 0v28.86a.596.596 0 0 1-.596.597zM29.344 53.708a.596.596 0 0 1-.596-.596V24.515a.596.596 0 0 1 1.193 0v28.593a.596.596 0 0 1-.597.6zM34.242 53.708a.597.597 0 0 1-.596-.596V24.515a.596.596 0 1 1 1.192 0v28.593a.597.597 0 0 1-.596.6zM39.052 53.708a.596.596 0 0 1-.596-.596V24.515a.596.596 0 1 1 1.193 0v28.593a.597.597 0 0 1-.597.6zM43.949 53.708a.596.596 0 0 1-.596-.596V24.515a.596.596 0 0 1 1.192 0v28.593a.597.597 0 0 1-.596.6z" fill="#fff"/><path d="M43.949 53.708a.596.596 0 0 1-.596-.596V24.515a.596.596 0 0 1 1.192 0v28.593a.597.597 0 0 1-.596.6zM48.755 53.708a.596.596 0 0 1-.596-.596V24.515a.596.596 0 1 1 1.193 0v28.593a.595.595 0 0 1-.596.6zM53.653 53.708a.596.596 0 0 1-.585-.6V24.515a.596.596 0 1 1 1.193 0v28.593a.597.597 0 0 1-.608.6z" fill="#fff"/><path d="M53.653 24.845H5.096a.596.596 0 0 1 0-1.193h48.557a.596.596 0 1 1 0 1.193zM28.677 15.121a5.922 5.922 0 0 1-5.64-7.759.597.597 0 0 1 .989-.239l2.52 2.52a1.308 1.308 0 1 0 1.849-1.848l-3.53-3.53a.597.597 0 0 1-.175-.421V.596A.596.596 0 0 1 25.286 0h6.782a.596.596 0 0 1 .596.596V4.79a5.935 5.935 0 0 1-3.987 10.331zm-4.719-6.36a4.742 4.742 0 1 0 7.732-3.216.596.596 0 0 1-.219-.46V1.192h-5.589v2.385l3.355 3.355a2.5 2.5 0 1 1-3.534 3.534L23.958 8.76z" fill="#fff"/><path d="M12.74 20.937a.596.596 0 0 1-.361-1.07L26.292 9.283a.596.596 0 0 1 .72.95L13.097 20.818a.592.592 0 0 1-.357.12zM45.237 20.615a.593.593 0 0 1-.362-.123L33.26 11.667a.596.596 0 1 1 .72-.95l11.614 8.825a.597.597 0 0 1-.357 1.073z" fill="#fff"/></svg>
							</div>
						</Flip>
						<div className="top">
							<h2><FormattedMessage id="microservicios.area_aduanas" /></h2>
							<p><FormattedMessage id="microservicios.area_aduanas_desc" /></p>
						</div>
						<footer>
						<table>
							<tr>
								<td>
								<a className="btn btn-solid verde" href="https://arcatek.akzent.mx/index.php/es/soluciones" target="_blank" rel="noopener noreferrer"><img src={iconlink} alt="Link" aria-hidden="true"/><FormattedMessage id="microservicios.area_aduanas_soltec" /></a>
									</td>
							</tr>
						</table> 
						</footer>
					</div>
				</div>


			</div>
		</section>



  </Layout>
)

export default injectIntl(suite)
